var Dlrt;
(function (Dlrt) {
    class FilteredListView {
        makePageParameters(pageNumber) {
            return {
                pageNumber: pageNumber
            };
        }
        getActivatedFilters() {
            return [];
        }
        clearFilters() {
        }
        onSuccess(_results) {
        }
        constructor(options) {
            this.options = options;
            this.resultTemplate = Handlebars.compile($(options.resultTemplateSelector).html());
            this.resultsContainer = $(options.resultsContainerSelector);
            this.resultsCountContainer = $(options.resultsCountContainerSelector);
            this.refreshCallback = () => this.getResults();
            if (options.noResultsTemplateSelector) {
                this.noResultsTemplate = Handlebars.compile($(options.noResultsTemplateSelector).html());
            }
            if (options.spinnerTemplateSelector) {
                this.initSpinner(options.spinnerTemplateSelector);
            }
            if (options.errorTemplateSelector) {
                this.errorTemplate = Handlebars.compile($(options.errorTemplateSelector).html());
            }
            const filtersCount = $(this.options.filtersCountSelector || '.sidebar .delphi-search-filters-count');
            this.filtersCount = filtersCount.length > 0 ? filtersCount : null;
            if (this.filtersCount) {
                this.filtersCount.click(() => {
                    this.clearFilters();
                    this.getResults();
                });
            }
        }
        get RefreshCallback() {
            return this.refreshCallback;
        }
        getSortingValue() {
            return this.sortingValue;
        }
        initPager(pagerSelector) {
            this.pager = $(pagerSelector);
            this.pager.bootpag({
                total: 1,
                maxVisible: 10,
                page: 1,
                firstLastUse: true
            }).on('page', (e, n) => this.getResults(n));
        }
        initSpinner(spinnerTemplateSelector) {
            this.spinnerTemplate = Handlebars.compile($(spinnerTemplateSelector).html());
        }
        autoRefreshOnClick(selector) {
            this.autoRefreshOnEvent(selector, 'click');
        }
        autoRefreshOnChange(selector) {
            this.autoRefreshOnEvent(selector, 'change');
        }
        autoRefreshOnEvent(selector, event) {
            $(selector).on(event, (e) => this.getResults());
        }
        handleTagClick(tagSelector) {
            let that = this;
            $(tagSelector).on('click', function () {
                $(this).toggleClass('active');
                that.getResults();
            });
        }
        readTags(tagSelector) {
            return $(tagSelector).map(function () { return parseInt($(this).data('value')); }).toArray();
        }
        initSortingCombo(initialSortingValue, comboItemSelector, comboTextSelector) {
            this.sortingValue = initialSortingValue;
            let that = this;
            $(comboItemSelector).on('click', function (e) {
                that.sortingValue = $(this).data('value');
                $(comboTextSelector).text($(this).text());
                that.getResults();
            });
        }
        initResults(pageNumber) {
            this.getResults(parseInt(pageNumber) || 1);
        }
        getResults(pageNumber = 1) {
            this.resultsContainer.empty();
            this.resultsCountContainer.hide();
            if (this.spinnerTemplate) {
                this.resultsContainer.append(this.spinnerTemplate(null));
            }
            if (this.pager) {
                this.pager.hide();
            }
            let queryParameters = this.makeQueryParameters();
            queryParameters.pageNumber = pageNumber;
            queryParameters.itemsPerPage = this.options.itemsPerPage;
            $.ajax({
                type: 'GET',
                cache: false,
                url: this.options.queryUrl,
                data: queryParameters,
                traditional: true,
                success: data => this.onGetResults(data, pageNumber),
                error: () => this.onGetError()
            });
        }
        onGetResults(data, pageNumber) {
            this.resultsContainer.empty();
            this.resultsCountContainer.find('span').text(data.totalCount.toString());
            this.resultsCountContainer.show();
            this.dataTotalCount = data.totalCount;
            if (data.totalCount > 0) {
                if (this.pager && data.totalCount > this.options.itemsPerPage) {
                    this.pager.bootpag({ page: pageNumber, total: Math.ceil(data.totalCount / this.options.itemsPerPage) });
                    this.pager.show();
                }
                // needed to avoid Bundler&Minifier generating "for (const n of n.items)" which raises a JS runtime error
                const items = data.items;
                for (const i of items) {
                    this.resultsContainer.append(this.resultTemplate(i));
                }
            }
            else {
                const noResultHtml = this.noResultsTemplate ? this.noResultsTemplate(null) : "<p class='no-data-found'>No result found.</p>";
                this.resultsContainer.append(noResultHtml);
            }
            this.updateNavigationHistory(pageNumber);
            if (this.filtersCount) {
                const count = this.getActivatedFilters().map(b => b ? 1 : 0).reduce((left, right) => left + right, 0);
                this.filtersCount.text(count > 0 ? count : '');
            }
            this.onSuccess(data);
        }
        onGetError() {
            const errorMessage = this.errorTemplate ? this.errorTemplate(null) : "<p>An unexpected error occured while loading your products.</p>";
            this.resultsContainer.html(errorMessage);
        }
        updateNavigationHistory(pageNumber) {
            if (this.options.useNavigationHistory && window.history && window.history.replaceState) {
                const pageParameters = this.makePageParameters(pageNumber);
                const historyQueryParameters = HistoryHelper.makeHistoryParams(pageParameters);
                const newLocation = `${window.location.origin}${window.location.pathname}?${historyQueryParameters}`;
                window.history.replaceState(null, 'FilteredListView.getResults()', newLocation);
            }
        }
    }
    Dlrt.FilteredListView = FilteredListView;
    class HistoryHelper {
        static makeHistoryParams(params) {
            return new HistoryHelper().process(params);
        }
        constructor() {
            this.result = [];
        }
        process(params) {
            // $.param works fine except for array parameters, especially for array of a single element
            // => we use $.param to create individual query params for simple params, and handle arrays manually
            for (const p in params) {
                this.processParam(p, params[p]);
            }
            return this.result.join('&');
        }
        processParam(prefix, value) {
            // skip empty params to simplify result url
            if (!value) {
                return '';
            }
            if ($.isArray(value)) {
                this.processCompositeParam(prefix, value, HistoryHelper.makeArrayPrefix);
            }
            else if ($.isPlainObject(value)) {
                this.processCompositeParam(prefix, value, HistoryHelper.makeObjectPrefix);
            }
            else {
                this.result.push(`${prefix}=${encodeURIComponent(value)}`);
            }
        }
        processCompositeParam(prefix, params, makePrefix) {
            for (const p in params) {
                this.processParam(makePrefix(prefix, encodeURIComponent(p)), params[p]);
            }
        }
        static makeArrayPrefix(current, next) {
            return `${current}[${next}]`;
        }
        static makeObjectPrefix(current, next) {
            return `${current}.${next}`;
        }
    }
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=filteredListView.js.map
